<template>
  <section
    class="lg:max-w-[600px] lg:mx-auto lg:!px-0"
    :class="{ 'flex flex-col': !isCheckoutDesktopFlow }"
  >
    <StatusBar v-if="!isCheckoutDesktopFlow" />
    <section :class="{ 'h-full grow px-4': !isCheckoutDesktopFlow }">
      <h1 class="text-2xl md:text-4xl px-4 lg:px-0 font-bold font-heading">How many guests?</h1>

      <GuestSelection v-if="!isLoadingTable" @click:guest="setGuestCount" />
      <GuestSelectionSkeleton v-else />

      <div id="max-guests-warning" class="text-right font-sans">
        <template v-if="guest_html">
          <span v-html="guest_html" class="[&_a]:text-primary [&_a]:underline"></span>
        </template>
        <template v-else>
          More than {{ max_guests }}? Please
          <a id="contact-us-link" class="text-primary underline" :href="`mailto:${reply_to}`">
            contact us</a
          >.
        </template>
      </div>
      <GuestLegalLink class="block lg:hidden" />
      <CheckoutBottomBar hideNextButton />
    </section>
    <GuestLegalLink class="hidden lg:block" />
  </section>
</template>

<script lang="ts">
import { mapState, mapStores } from 'pinia'
import { defineComponent } from 'vue'

import GuestLegalLink from '@/modules/guestUi/components/atoms/GuestLegalLink.vue'
import GuestSelectionSkeleton from '@/modules/guestUi/components/molecules/GuestSelectionSkeleton.vue'
import CheckoutBottomBar from '@/modules/guestUi/components/organisms/CheckoutBottomBar.vue'
import GuestSelection from '@/modules/guestUi/components/organisms/GuestSelection.vue'
import StatusBar from '@/modules/guestUi/components/organisms/StatusBar.vue'
import { useCheckoutStore } from '@/stores/checkout'
import { useSettingStore } from '@/stores/setting'
import { blankError } from '@/utils/errors'

export default defineComponent({
  name: 'SetGuests',
  components: {
    CheckoutBottomBar,
    GuestSelectionSkeleton,
    GuestSelection,
    GuestLegalLink,
    StatusBar,
  },
  data() {
    return {
      guestCount: 0,
      prevRoute: null,
      isLoadingTable: true,
      ui: {
        error: blankError(),
      },
    }
  },

  beforeRouteEnter(_, from, next) {
    next(vm => {
      // @ts-ignore
      vm.prevRoute = from
    })
  },

  async mounted() {
    this.checkoutStore.clearNumberOfGuests()
    await this.checkoutStore.refreshPerformance()
    this.isLoadingTable = false
  },

  computed: {
    ...mapStores(useCheckoutStore),
    ...mapState(useSettingStore, ['max_guests', 'reply_to', 'guest_html']),

    isCheckoutDesktopFlow(): boolean {
      return this.checkoutStore.isDesktopFlow
    },
  },

  methods: {
    async setGuestCount(count: number) {
      await this.checkoutStore.setNumberOfGuests(Number(count), this.ui.error)
    },

    onBack() {
      history.go(-1)
    },
  },
})
</script>
